import { Text } from 'design/text';
import React from 'react';
import { PictureIcon } from 'svg/72x72/picture';

import styles from './NewsArticle.module.css';

type TProps = {
  src: null | File | string;
};

export const NewsArticleImage = ({ src }: TProps) => {
  const imageSrc = React.useMemo(() => {
    if (src instanceof File) {
      return URL.createObjectURL(src);
    }
    return src;
  }, [src]);

  return (
    <div className={styles.NewsArticle__ImageWrapper}>
      {imageSrc ? (
        <img src={imageSrc} alt="" className={styles.NewsArticle__Image} />
      ) : (
        <div className={styles.NewsArticle__ImagePlaceholder}>
          <Text color="secondary">
            <PictureIcon />
          </Text>
        </div>
      )}
    </div>
  );
};
